import type { IMAIROQuestionsHeader } from '../interfaces/IMAIROQuestionsHeader';

import styles from '../scss/MAIROQuestionHeader.module.scss';

function MAIROQuestionHeader({
  title,
  description,
  descriptionKey,
  valueChainSection,
}: IMAIROQuestionsHeader) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <p>{title}</p>
        <div className={styles.statusCell}>
          <span className={`${styles.statusText} ${styles[valueChainSection]}`}>
            <span>{valueChainSection}</span>
          </span>
        </div>
      </div>
      <div className={styles.description}>
        <span>{descriptionKey}</span>
        <span>{description}</span>
      </div>
    </div>
  );
}

export default MAIROQuestionHeader;
